<template>
	<div>
		<vs-popup
			:active.sync="showDetailsPopup"
			title="Détails de la Recherche de Prospects"
		>
			<vs-table
				v-if="selectedProspectSearch"
				noDataText=""
				:data="selectedProspectSearch.prospect_list"
				stripe
				auto-resize
			>
				<template slot="thead">
					<vs-th>URL</vs-th>
					<vs-th>Position moyenne</vs-th>
					<vs-th>DA</vs-th>
					<vs-th>PA</vs-th>
					<vs-th>Domaines Référents</vs-th>
					<vs-th>Liens entrants</vs-th>
				</template>

				<template slot-scope="{ data }">
					<vs-tr>
						<div v-show="false">
							{{ setRowNum(data.length) }}
						</div>

						<vs-td>
							<vs-button
								v-if="showKeywords"
								color="primary"
								class="mt-2 w-full"
								@click="displayKeywords(false)"
								>Cacher les Keywords</vs-button
							>
							<vs-button
								v-else
								color="primary"
								class="mt-2 w-full"
								@click="displayKeywords(true)"
								>Voir les Keywords</vs-button
							>
						</vs-td>
						<vs-td></vs-td>
						<vs-td></vs-td>
						<vs-td></vs-td>
						<vs-td></vs-td>
					</vs-tr>
					<vs-tr v-if="showKeywords">
						<vs-td colspan="5"
							><vs-chip
								:key="indexKeyword"
								v-for="(
									oneKeyword, indexKeyword
								) in selectedProspectSearch.keyword_list.split(',')"
								>{{ oneKeyword }}</vs-chip
							></vs-td
						>
					</vs-tr>
					<vs-tr :key="index" v-for="(onePs, index) in data">
						<vs-td
							><span>{{ onePs.url }}</span></vs-td
						>
						<vs-td><span></span></vs-td>
						<vs-td
							><span>{{ onePs.domain_authority }}</span></vs-td
						>
						<vs-td
							><span>{{ onePs.page_authority }}</span></vs-td
						>
						<vs-td
							><span>{{ onePs.referring_domains }}</span></vs-td
						>
						<vs-td
							><span>{{ onePs.referring_links }}</span></vs-td
						>
					</vs-tr>
				</template>
			</vs-table>
		</vs-popup>
		<vs-popup
			:active.sync="showValidationPopup"
			title="Êtes-vous sûr de vouloir valider la supression du nom de domaine ?"
		>
			<div class="vx-row">
				<div class="vx-col sm:w-1/2">
					<vs-button color="primary" class="mt-2 w-full" @click="accept()"
						>Oui</vs-button
					>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button color="primary" class="mt-2 w-full" @click="decline()"
						>Non</vs-button
					>
				</div>
			</div>
		</vs-popup>
		<vs-table :data="$props.ps" stripe auto-resize>
			<template slot="thead">
				<vs-th>Nom de la recherche</vs-th>
				<vs-th>Nombre d'URLs</vs-th>
				<vs-th>Nombre de Top Keywords</vs-th>
				<vs-th>Créateur</vs-th>
				<vs-th>Date de création</vs-th>
				<vs-th></vs-th>
				<vs-th></vs-th>
				<!-- <vs-th></vs-th>
        <vs-th></vs-th> -->
				<vs-th v-if="$acl.check('sadmin')"></vs-th>
			</template>

			<template slot-scope="{ data }">
				<vs-tr :key="index" v-for="(onePs, index) in data">
					<div v-show="false">
						{{ setRowNum(data.length) }}
					</div>
					<vs-td :data="onePs.name">{{ onePs.name }}</vs-td>
					<vs-td :data="onePs.prospects_count">{{
						onePs.prospects_count ? onePs.prospects_count : 0
					}}</vs-td>
					<vs-td :data="onePs.keywords_count">{{
						onePs.keywords_count ? onePs.keywords_count : 0
					}}</vs-td>
					<vs-td :data="onePs.user_id">
						<div class="vx-row center-content">
							<vx-tooltip
								:text="getCollaboratorName(onePs.user_id)"
								position="top"
							>
								<vs-avatar
									style="border: 1px solid"
									badge=""
									badge-color="rgb(140, 23, 164)"
									:text="getCollaboratorName(onePs.user_id)"
									:src="getCollaboratorAvatar(onePs.user_id)"
								/>
							</vx-tooltip>
						</div>
					</vs-td>
					<vs-td :data="onePs.creation_date">{{
						formatDate(onePs.creation_date)
					}}</vs-td>
					<vs-td>
						<vx-tooltip text="Voir les détails" position="top">
							<!-- <vs-button size="large"
                         color="primary"
                         type="flat"
                         icon-pack="feather"
                         icon="icon-eye"
                         @click="displayProspectSearchDetails(onePs)">
              </vs-button> -->
							<vs-button
								size="large"
								color="primary"
								type="flat"
								icon-pack="feather"
								icon="icon-eye"
								@click="showDetails(onePs)"
							>
							</vs-button>
						</vx-tooltip>
					</vs-td>
					<!--
          <vs-td :data="onePs.anchor_type">{{ getNetlinkAnchorType(onePs.anchor_type) }}</vs-td>
          <vs-td :data="onePs.link_type">{{ getNetlinkLinkType(onePs.link_type) }}</vs-td>
          <vs-td :data="onePs.purchase_id"> {{ onePs.creation_date ? getDateToFrenchFormat(onePs.creation_date.substring(0,10)) : getDateToFrenchFormat(getPurchaseIdToPurchaseDate(onePs.purchase_id)) }}</vs-td>
          <vs-td :data="onePs.status">
            <vs-chip
              style="width: 80px"
              :color="getNetlinkStatusColor(onePs.status)"
              class="ml-2"
              >{{
              getNetlinkStatus(onePs.status)
            }}</vs-chip></vs-td> -->
					<!-- <vs-td>
            <vx-tooltip text="Ajouter" position="top">
              <vs-button size="large"
                         color="primary"
                         type="flat"
                         icon-pack="feather"
                         icon="icon-plus-circle"
                         @click="$router.push({ name: 'new_entity', params: { newEntityForm: 'netlink', dns: onePs.id } })"></vs-button>
            </vx-tooltip>
          </vs-td> -->
					<!-- <vs-td>
            <vx-tooltip text="Modifier" position="top">
              <vs-button size="large"
                         color="primary"
                         type="flat"
                         icon-pack="feather"s
                         icon="icon-edit-2"
                         @click="updateDns(onePs)"></vs-button>
            </vx-tooltip>
          </vs-td> -->
					<vs-td>
						<vx-tooltip text="Modifier" position="top">
							<vs-button
								size="large"
								color="primary"
								type="flat"
								icon-pack="feather"
								icon="icon-edit"
								@click="editProspect(onePs)"
							></vs-button>
						</vx-tooltip>
					</vs-td>
					<vs-td v-if="$acl.check('sadmin')">
						<vx-tooltip text="Effacer" position="top">
							<vs-button
								size="large"
								color="danger"
								type="flat"
								icon-pack="feather"
								icon="icon-trash-2"
								@click="displayValidationPopup(onePs)"
							></vs-button>
						</vx-tooltip>
					</vs-td>
				</vs-tr>
			</template>
		</vs-table>
	</div>
</template>

<script>
import store from "@/store/store";
import utilsMixin from "@/mixins/utilsMixin.js";
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin.js";
// import Purchase from "@/entities/Purchase"
import ProspectSearch from "@/entities/ProspectSearch";

export default {
	name: "ProspectsTable",
	props: {
		ps: Array,
		// services: Array,
	},
	mixins: [utilsMixin, dbFieldConvertorMixin],
	components: {},
	data() {
		return {
			apiErrorMsg: null, // catching api error message
			showDetailsPopup: false,
			showKeywords: false,
			showValidationPopup: false,
			psToDelete: null,
			selectedProspectSearch: null,
			langList: [
				{ name: "Français", country: "France", id: 1 },
				{ name: "Anglais", country: "USA", id: 2 },
				{ name: "Anglais", country: "UK", id: 3 },
				{ name: "Chinois simplifié", country: "RPC", id: 4 },
				{ name: "Japonais", country: "Japon", id: 5 },
				{ name: "Coréen", country: "Corée du Sud", id: 6 },
			],
		};
	},
	created() {
		if (this.$props.ps.length == 0) {
			this.setRowNum(0);
		}
		// this.getAllSocieties()
		this.getAllCollaborators();
		this.getAllCollaboratorsAvatar();
		/*
		 * this.getAllServices()
		 * this.getAllPurchases();
		 */
	},
	mounted() {},
	computed: {
		/*
		 * societies: () => {
		 *   return store.state.societies;
		 * },
		 */
		providers: () => {
			return store.state.providers;
		},
		/*
		 * services: () => {
		 *   return store.state.services;
		 * },
		 * purchases: () => {
		 *   return store.state.purchases;
		 * },
		 */
		allCollaborators: () => {
			return store.state.collaborators;
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
	},
	watch: {
		ps: function (data) {
			if (data.length == 0) {
				this.setRowNum(0);
			}
		},
		/*
		 * purchases: function(){
		 *     //console.log("purchases watch")
		 *     // this.createChips(this.providers)
		 * }
		 */
	},

	methods: {
		setRowNum(len) {
			store.dispatch("setRowNum", len);
		},

		getAllCollaborators() {
			this.$store.dispatch("getAllCollaborators");
		},

		getAllCollaboratorsAvatar() {
			this.$store.dispatch("getAllCollaboratorsAvatar");
		},

		getCollaboratorAvatar(userId) {
			let foundAvatar = this.allCollaboratorsAvatar.find(
				(avatar) => avatar.id == userId
			);
			if (foundAvatar) return foundAvatar.avatar;
			else return null;
		},

		getCollaboratorName(userId) {
			let foundCollaborator = this.allCollaborators.find(
				(avatar) => avatar.id == userId
			);
			if (foundCollaborator)
				return `${foundCollaborator.firstname} ${foundCollaborator.lastname}`;
			else return null;
		},

		displayKeywords(state) {
			this.showKeywords = state;
		},

		displayProspectSearchDetails(ps) {
			this.selectedProspectSearch = ps;
			this.showDetailsPopup = true;
		},
		showDetails(ps) {
			this.$emit("show-details", ps);
		},
		editProspect(ps) {
			this.$emit("edit-prospect", ps);
		},
		updateProspectSearch(ps) {
			this.$emit("modify-ps", ps);
		},

		/**
		 * Fetch all the purchases
		 */
		/*
		 * getAllPurchases() {
		 *   ////console.log("getAllNetlink BEGIN")
		 *   this.$store.dispatch("getAllPurchases");
		 *   ////console.log("getAllNetlink END")
		 * },
		 */

		/**
		 * Add prefix to url using the mixin
		 */
		getPrefixedUrl(url) {
			return this.urlPrefixAdder(url);
		},

		/**
		 * Returns service name from service id
		 * @param {Number} service_id - service id to retrieve name from
		 * @return {String} - name of service id
		 */
		/*
		 * getServiceIdToName(service_id){
		 *   let service_name = ""
		 *   let service = this.services.find(service => service.id == service_id)
		 *   service_name = service.name;
		 *   return service_name
		 * },
		 */

		/*
		 * getSocietyIdToName(society_id){
		 *   let society_name = ""
		 *   let society = this.societies.find(society => society.id == society_id)
		 *   society_name = society.name;
		 *   return society_name
		 * },
		 */

		getProviderIdToName(provider_id) {
			// let provider_name = ""
			let provider = this.providers.find(
				(provider) => provider.id == provider_id
			);
			let provider_name = provider ? provider.society : "";
			return provider_name;
		},

		getLangIdToName(lang_id) {
			// let provider_name = ""
			let lang = this.langList.find((lang) => lang.id == lang_id);
			let lang_name = lang ? `${lang.name} (${lang.country})` : "";
			return lang_name;
		},

		/*
		 * getSocietyName(society_id){
		 *   let society_name = ""
		 *   let society = this.societies.find(society => society.id == society_id)
		 *   society_name = society.name
		 *   return society_name
		 * },
		 */

		/*
		 * getPurchaseIdToSocietyName(purchase_id){
		 *   let society_name = ""
		 *   let purchase = this.purchases.find(purchase => purchase.id == purchase_id)
		 *   let society_id = purchase.contract_society_id;
		 *   let society = this.societies.find(society => society.id == society_id)
		 *   society_name = society.name
		 *   return society_name
		 * },
		 */

		/*
		 * getPurchaseIdToPurchaseDate(purchase_id){
		 *   let purchase_date = ""
		 *   let purchase = this.purchases.find(purchase => purchase.id == purchase_id)
		 *   purchase_date = purchase.bought_at
		 *   return purchase_date.substring(0,10)
		 * },
		 */

		formatDate(date_input) {
			if (date_input && date_input.length > 10) {
				return date_input.substring(0, 10).split("-").reverse().join("/");
			} else {
				return date_input.split("-").reverse().join("/");
			}
		},
		// getAllServices(){
		//   this.$store.dispatch("getAllServices");
		// },
		// /**
		//  * Get all societies in store states
		//  */
		// getAllSocieties(){
		//   this.$store.dispatch("getAllSocieties");
		// },
		getAllProviders() {
			this.$store.dispatch("getAllProviders");
		},

		deleteProspectSearch(ps) {
			ProspectSearch.archive(ps.id, (err, res) => {
				if (err) {
					this.$vs.notify({
						title: "Error",
						text: "Erreur lors de la suppression de la recherche",
						color: "danger",
					});
				}
				if (res) {
					this.$emit("delete-line", ps);
					this.$vs.notify({
						title: "Succès",
						text: "Recherche supprimée avec succès",
						color: "success",
					});
				}
			});
		},

		updateDns(ps) {
			this.$emit("modify-ps", ps);
		},

		displayValidationPopup(ps) {
			this.psToDelete = ps;
			this.showValidationPopup = true;
		},

		accept() {
			this.deleteProspectSearch(this.psToDelete);
			this.showValidationPopup = false;
		},

		decline() {
			this.psToDelete = null;
			this.showValidationPopup = false;
		},
	},
};
</script>

<style scoped>
.center {
	justify-content: center;
}

.hvr-underline-out {
	color: black;
}
.hvr-underline:hover {
	color: aqua;
	text-decoration: underline;
	cursor: pointer;
}
.chip {
	text-align: center;
	border-radius: 20px;
	background-color: #f0f0f0;
	padding: 5px 10px;
	font-size: 0.8rem;
	display: inline-block;
}
</style>
